import { SunClockIcon } from './SunClockIcon';

/**
 * author: Hans Böhm
 * id B467AA69-1E9D-444C-B6E4-764F1D180140
 * name sun-clock
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sun-clock.svg
 * tags
 * - Weather 
 * - Home Automation 
 */
export const SunScheduleIcon = SunClockIcon;
export default SunScheduleIcon